import React from "react";
import { Route, RouteComponentProps, Switch } from "react-router";
import { withBreadCrumbs } from "lego-gui-lib/lib";
import { Index } from "./IndexView";
import { Create, Clone } from "./CreateView";
import { Config } from "./ConfigView/ConfigView";
import i18next from "i18next";
import { Show } from "./ShowView/ShowView";
import { ParentRoute } from "../../core/model/parent";

export const SANs = {
  url: "/sans",
  handler: (props: RouteComponentProps<any>) => {
    const title = i18next.t("hns:san:domain_plural");
    const baseUrl = props.match.url;

    return withBreadCrumbs(
      { to: baseUrl, children: title },
      <>
        <ParentRoute path={baseUrl + "/:id"} dataSourceName={"SAN"} />
        <Switch>
          <Route exact={true} path={baseUrl} component={Index} />
          <Route path={baseUrl + "/create/:id"} component={Clone} />
          <Route path={baseUrl + "/create"} component={Create} />
          <Route path={baseUrl + "/:id/configure"} component={Config} />
          <Route path={baseUrl + "/:id"} component={Show} />
        </Switch>
      </>
    );
  }
};
